module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "banner_1.e17b14c7.webp" + "?" + Date.now();